import React from "react";
import SbEditable from "storyblok-react"
import RichText from "src/utils/RichText";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import FluidImage from "src/utils/FluidImage";
import Cloud from "src/images/cloud.svg"
import { BackgroundColour, ContentColourFromBackground, HeadingColourFromBackground, FillColour, ButtonColourFromBackground } from "src/utils/ColourUtilities";
import ArrowButton from "src/components/ArrowButton"
import ConnectCharacter from "src/images/connect_character_2.svg"
import InspectCharacter from "src/images/inspect_character.svg"
import Tube from "src/images/tube.svg"
import { Weight } from "lucide-react";

const Card = (props) => {
    return (
        <div 
            className={`rounded-lg flex justify-between items-center gap-2 overflow-hidden
            ${BackgroundColour(props.background_colour)}
            ${props.full_width ? 'md:col-span-3 sm:flex-row flex-col' : 'md:col-span-1 flex-col'}
            `}
        >
            <div 
                className={`
                ${props.full_width ? 'lg:p-16 p-6 lg:pt-16 pt-10 lg:pb-16 pb-0 lg:w-1/2 w-full ' : 'px-6 lg:pt-11 pt-10 pb-0 w-full'}
                ${props.flip ? 'lg:order-last' : ''}
                `}
            >
                <Label className={`${ContentColourFromBackground(props.background_colour)} text-sm !mb-6`} p={true}>{props.label}</Label>
                <Heading 
                   size={'h3'}
                   className={`${props.full_width ? `lg:max-w-[442px] md:max-w-[300px] max-w-[231px] font-semibold lg:text-[40px] md:text-[32px] text-2xl` :`font-display  font-semibold tracking-[-1px] lg:!text-2xl lg:flex md:text-xl text-base -mt-8 ` }${HeadingColourFromBackground(props.background_colour, true)}`}
                >
               <div className="lg:flex ">
                    {!props.full_width && props?.CardSvg?.filename && (
                    <img
                        src={props?.CardSvg?.filename}
                        alt="Tube"
                        className="h-[40px] w-[40px] lg:object-contain mt-10"
                    />
                    )}
                    <div>
                    <RichText>{props.title}</RichText>
                    </div>
                </div>

                </Heading>
                <div className={`${ContentColourFromBackground(props.background_colour)} prose mt-4 text-sm tracking-[-0.02em]`}>
                    <RichText>{props.description}</RichText>
                </div>
                <ArrowButton
                    to={props.button_target?.cached_url}
                    target={props.button_target?.linktype === 'url' ? '_blank' : ''}
                    className={`${ButtonColourFromBackground(props.background_colour)} font-semibold group lg:ml-10 p-4 pl-0`}
                >
                    {props.button_text}
                </ArrowButton>
            </div>
            <div 
                className={`relative
                ${props.full_width ? 'md:p-16 p-6 lg:pt-16 pt-6 md:w-1/2 w-full' : 'p-6 w-full'}
                ${props.remove_image_padding ? '!p-0' : ''}
                ${props.smaller_image ? '!w-4/6' : ''}
                `}
            >
                <FluidImage className="object-cover object-center mx-auto lg:max-w-[442px] md:max-w-[300px] max-w-[231px]" image={props.image}/>
                {props.image_shape_overlay &&
                    <Cloud
                        className={`absolute z-20 top-0 left-0 w-full h-full
                        ${FillColour(props.background_colour)}
                        ${props.full_width ? 'lg:p-16 p-6 lg:pt-16 pt-6' : 'p-[calc(1.5rem-0.5px)]'}
                        `}
                    />
                }
            </div>
        </div>
    )
}

const MultiCards = ({blok}) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
        <div className="lg:my-40 md:32 my-16">
            <div className="max-w-7xl mx-auto">
                {blok.character === 'inspect' && 
                    <InspectCharacter className="-mb-44 ml-20 lg:block hidden"/>
                }
                {blok.character === 'connect' && 
                    <ConnectCharacter className="-mb-16 ml-20 lg:block hidden"/>
                }
            </div>
            <div className={`relative bg-white`}>
                <div className={`relative lg:max-w-5xl md:max-w-3xl mx-auto px-6 `}>
                    <div className={`grid md:grid-cols-3 grid-cols-1 gap-4`}>
                        {blok?.cards?.map((card) => (
                            <Card {...card}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </SbEditable>
  );
};

export default MultiCards;